import Vue from 'vue'

const client = Vue.prototype.$api

export default {
  getProfessionals (params, hideLoadingIcon) {
    return client.get('search/professionals', { params: params, loading: !hideLoadingIcon })
  },
  getCompaniesProfessionals (params, hideLoadingIcon) {
    return client.get('search/companiesProfessionals', { params: params, loading: !hideLoadingIcon })
  },
  getCenters (params, hideLoadingIcon) {
    return client.get('search/centers', { params: params, loading: !hideLoadingIcon })
  },
  getCentersAndProfs (params, hideLoadingIcon) {
    return client.get('search/centersAndProfessionals', { params: params, loading: !hideLoadingIcon })
  },
  getProfsByName (name) {
    return client.get('search/professionals-basic-info', { params: { name: name } })
  },
  getCentersByName (name) {
    return client.get('search/centersByName', { params: { name: name } })
  },
  getProfById (profId) {
    return client.get(`search/professionals-basic-info/${profId}`)
  },
  getPatientById (patientId) {
    return client.get(`search/patient-basic-info/${patientId}`)
  }
}


// WEBPACK FOOTER //
// ./src/repositories/SearchRepository.js